import {h} from 'preact'

export default ({onClick, title}) => {
    let src = "/assets/images/icon-star.svg";
    return (
        <div className="desktop-box">
            <button onClick={onClick} className="btn-small leave-request-opener">
                <img src={src} alt="" />
                <span>{title}</span>
            </button>
        </div>
    )
}